import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { CustomMemberGroupStoreContext } from '../contexts/StoreContext'
import { CustomMemberGroupStore } from '../store/interface'

export const useCustomMemberGroupStore: UseStore<
  CustomMemberGroupStore
> = selector => {
  return useContextStore(CustomMemberGroupStoreContext, selector)
}

export const useCustomMemberGroupStoreApi = () => {
  return useContextStoreApi(CustomMemberGroupStoreContext)
}
